'use client';

import { Box, Container, Typography, Grid, Chip } from '@mui/material';
import { dronesData } from '@/data/proyectos/drones/dronesData';

export default function HeroSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        paddingTop: {xs : '10px', md: '5vh'},
        height: { xs: '90vh', md: '70vh' },
         minHeight: '600px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        color: 'white',
      }}
    >
      {/* Imagen de fondo con overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 30, 60, 0.8)), url(${dronesData.hero.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          zIndex: 1,
        }}
      />
      
      {/* Patrón de ruido sutil */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z" fill="%23000000" fill-opacity="0.05" fill-rule="evenodd"/%3E%3C/svg%3E")',
          opacity: 0.3,
          zIndex: 2,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 3 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 7 }}>
            <Chip 
              label="TECNOLOGÍA AVANZADA" 
              sx={{ 
                bgcolor: 'rgba(0, 150, 255, 0.2)', 
                color: '#4fc3f7',
                fontWeight: 600,
                mb: 3,
                px: 1
              }}
            />
            
            <Typography
              variant="h1"
              sx={{
                fontWeight: 800,
                fontSize: { xs: '2.5rem', md: '3.5rem', lg: '4rem' },
                lineHeight: 1.2,
                mb: 2,
                background: 'linear-gradient(135deg, #ffffff 30%, #4fc3f7 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {dronesData.hero.title}
            </Typography>
            
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                fontWeight: 300,
                opacity: 0.9,
                maxWidth: '90%'
              }}
            >
              {dronesData.hero.subtitle}
            </Typography>
            
            <Typography
              variant="body1"
              sx={{
                mb: 5,
                fontSize: '1.1rem',
                opacity: 0.85,
                maxWidth: '85%',
                lineHeight: 1.8
              }}
            >
              {dronesData.hero.description}
            </Typography>
            
            
          </Grid>
          
          <Grid size={{ xs: 12, md: 5 }}>
            {/* Estadísticas */}
            <Box
              sx={{
                // bgcolor: 'rgba(255, 255, 255, 0.1)',
                // backdropFilter: 'blur(10px)',
                borderRadius: 3,
                p: 8,
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}
            >
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                {/* Métricas Clave */}
              </Typography>
              <Grid container spacing={3}>
                {dronesData.hero.stats.map((stat, index) => (
                  <Grid key={index} size={{ xs: 6, sm: 4, md: 12 }}>
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: 700,
                          background: 'linear-gradient(135deg, #4fc3f7, #29b6f6)',
                          backgroundClip: 'text',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          mb: 0.5
                        }}
                      >
                        {stat.value}
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        {stat.label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}